import script from "./FileList.vue?vue&type=script&setup=true&lang=js"
export * from "./FileList.vue?vue&type=script&setup=true&lang=js"

import "./FileList.vue?vue&type=style&index=0&id=112a5dc8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-112a5dc8"]])

export default __exports__